import { configurationSettings } from '../../../configuration';
import { sessionDomainStore } from '../store';
export const getLanguageTag = () => {
    var _a, _b;
    return ((_a = sessionDomainStore.data.languageTag) !== null && _a !== void 0 ? _a : (_b = configurationSettings.data.languages.find(language => language.isDefault)) === null || _b === void 0 ? void 0 : _b.languageTag);
};
//# sourceMappingURL=get-language-tag.js.map